import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
const {REACT_APP_REST_ENDPOINT} = process.env;

const ProtectedContent = ({ show, onHide, selectedContenuto }) => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token');

  const user = useSelector(state => state.user.userData);
  const showAudioVideoContent = user.tipo_utente === 'admin' || user.tipo_utente === 'developer' || user.tipo_utente === 'docente' || user.tipo_utente === 'course_designer' || (user.tipo_utente === 'corsista' && selectedContenuto?.tipo_contenuto === 'audio-video');

  useEffect(() => {
    if (!show) {
      setContent(null);
      setLoading(true);
      setError(null);
    }
  }, [show]);

  useEffect(() => {
    if (show && selectedContenuto) {
      if (selectedContenuto.tipo_contenuto === 'testo-immagini') {
        setContent(selectedContenuto.contenuto);
        setLoading(false);
        return;
      }

      if (!selectedContenuto.url_contenuto && selectedContenuto.tipo_contenuto !== 'pdf') {
        setError('Contenuto non disponibile');
        setLoading(false);
        return;
      }

      if (selectedContenuto?.formato_contenuto === 'link') {
        handleExternalContent();
      } else if (showAudioVideoContent) {
        setContent(selectedContenuto.url_contenuto);
        setLoading(false);
      } else {
        fetchProtectedContent();
      }
    }
  }, [show, selectedContenuto, showAudioVideoContent]);

  const handleExternalContent = () => {
    try {
      let embedUrl = selectedContenuto?.url_contenuto;

      if (selectedContenuto?.url_contenuto.includes('youtube.com/watch')) {
        const videoId = new URL(selectedContenuto?.url_contenuto).searchParams.get('v');
        embedUrl = `https://www.youtube.com/embed/${videoId}`;
      } 
      else if (selectedContenuto?.url_contenuto.includes('youtu.be')) {
        const videoId = selectedContenuto?.url_contenuto.split('/').pop();
        embedUrl = `https://www.youtube.com/embed/${videoId}`;
      }
      else if (selectedContenuto?.url_contenuto.includes('vimeo.com')) {
        const videoId = selectedContenuto?.url_contenuto.split('/').pop();
        embedUrl = `https://player.vimeo.com/video/${videoId}`;
      }

      setContent(embedUrl);
      setLoading(false);
    } catch (err) {
      setError('Errore nel processare il link esterno');
      setLoading(false);
    }
  };

  const fetchProtectedContent = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${REACT_APP_REST_ENDPOINT}/file/serve`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          id_contenuto: selectedContenuto?.id_contenuto
        })
      });
  
      if (!response.ok) throw new Error('Errore nel caricamento del contenuto');
      
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      setContent(objectUrl);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const renderLoading = () => (
    <div className="d-flex flex-column align-items-center justify-content-center p-5">
      <div className="spinner-border text-primary mb-3" role="status">
        <span className="visually-hidden">Caricamento...</span>
      </div>
      <div className="text-center">
        <h5 className="mb-2">Caricamento contenuto in corso...</h5>
        <p className="text-muted mb-0">Attendere il completamento del caricamento</p>
      </div>
    </div>
  );

  const renderContent = () => {
    if (loading) return renderLoading();
    if (error) return (
      <div className="text-center text-danger p-4">
        <i className="bi bi-exclamation-circle-fill fs-1 mb-3 d-block"></i>
        <h5>Contenuto non disponibile</h5>
        <p className="mb-0">Il contenuto che stai cercando di visualizzare non è al momento disponibile.</p>
      </div>
    );

    if (selectedContenuto?.tipo_contenuto === 'testo-immagini') {
      return (
        <div className="p-4">
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      );
    }

    if (selectedContenuto?.formato_contenuto === 'link') {
      return (
        <iframe
          src={content}
          className="w-100"
          style={{ height: '80vh' }}
          title="External Content"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      );
    }

    switch (selectedContenuto?.tipo_contenuto) {
      case 'pdf':
          return (
            <div className="text-center p-4">
              <i className="bi bi-file-earmark-pdf fs-1 text-primary mb-3 d-block"></i>
              <h5 className="mb-3">Il documento è pronto per il download</h5>
              <a 
                href={content}
                download={`${selectedContenuto?.titolo || 'documento'}.pdf`}
                className="btn btn-primary"
              >
                Scarica PDF
              </a>
            </div>
          );
      case 'documento-testo':
        return (
          <div className="text-center p-4">
            <i className="bi bi-file-earmark-word fs-1 text-primary mb-3 d-block"></i>
            <h5 className="mb-3">Il documento è pronto per il download</h5>
            <a 
              href={content}
              download
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault();
                const link = document.createElement('a');
                link.href = content;
                link.download = `${selectedContenuto?.titolo || 'documento'}.docx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
            >
              Scarica documento
            </a>
          </div>
        );
      case 'audio-video':
        return (
          <video
            controls
            className="w-100"
            style={{ maxHeight: '100vh' }}
            onContextMenu={e => e.preventDefault()}
          >
            <source src={content} type="video/mp4" />
            Il tuo browser non supporta il tag video.
          </video>
        );
      default:
        return <div className="p-3" dangerouslySetInnerHTML={{ __html: content }} />;
    }
  };
  console.log(content, 'content');
  
  return (
    <Modal 
      show={show} 
      onHide={() => {
        setContent(null);
        setLoading(true);
        setError(null);
        onHide();
      }} 
      size="lg" 
      centered
      backdrop="static"
      keyboard={!loading}
    >
      <Modal.Header className='justify-content-end' closeButton>
        {selectedContenuto?.titolo && (
          <Modal.Title className='fw-bold'>
            {selectedContenuto?.titolo}
          </Modal.Title>
        )}
      </Modal.Header>
      <Modal.Body className="p-0">
        {renderContent()}
      </Modal.Body>
    </Modal>
  );
};

export default ProtectedContent;